import { render, staticRenderFns } from "./AIComponent.vue?vue&type=template&id=7548f8e8&scoped=true&"
import script from "./AIComponent.vue?vue&type=script&lang=js&"
export * from "./AIComponent.vue?vue&type=script&lang=js&"
import style0 from "./AIComponent.vue?vue&type=style&index=0&id=7548f8e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7548f8e8",
  null
  
)

export default component.exports